import React, { useEffect, useMemo, useState } from "react";
import { Worker, Viewer, ScrollMode } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';
import { useDocumentViewerReducer } from "../../redux/slice/documentViewerSlice";
import { searchPlugin } from '@react-pdf-viewer/search';
import '@react-pdf-viewer/search/lib/styles/index.css';
import { RiArrowDownLine, RiArrowUpLine } from "react-icons/ri";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import AlertMessage from "../common/AlertMessage";

const DocumentViewer = () => {
    const searchPluginInstance = searchPlugin();

    const { base64String, documentFetchStatus } = useDocumentViewerReducer();
    const [pdfLoaded, setPdfLoaded] = useState(false);
    const [currentLocation, setCurrentLocation] = React.useState({
        index: 0,
        length: 0,
    })
    const [alertMessage, setAlertMessage] = useState("");

    useEffect(() => {
        setCurrentLocation({
            index: 0,
            length: 0
        })
        setAlertMessage("")
        if (!pdfLoaded) return;
        setTimeout(() => {
            const allSpans = document.querySelectorAll('span');
            const marker = Array.from(allSpans).filter(span => span.textContent?.includes('~~'));
            if (marker && marker.length > 0) {
                setCurrentLocation({
                    index: 0,
                    length: marker.length
                })
            } 
            else
                setAlertMessage("Does not reflect on the PDF.")
        }, 500);
    }, [pdfLoaded]);

    useEffect(()=>{
        if (documentFetchStatus === 'loading')
            setPdfLoaded(false)
    }, [documentFetchStatus])

    useEffect(() => {
        const { index, length } = currentLocation;
        if (length > 0 && length > index) {
            const allSpans = document.querySelectorAll('span');
            const marker = Array.from(allSpans)?.filter(span => span.textContent?.includes('~~'));
            if (Array.isArray(marker) && marker[index]) {
                marker[index].scrollIntoView({ behavior: "smooth", block: "nearest" });
            }
        }
    }, [currentLocation])

    const blobUrl = useMemo(() => {
        try {
            if (!base64String) return null;

            const raw = atob(base64String);
            const uint8Array = new Uint8Array(raw.length);
            for (let i = 0; i < raw.length; i++) {
                uint8Array[i] = raw.charCodeAt(i);
            }
            const blob = new Blob([uint8Array], { type: "application/pdf" });
            return URL.createObjectURL(blob);
        } catch (error) {
            console.log("Failed to create PDF Blob URL:", error);
            return null;
        }
    }, [base64String]);

    useEffect(() => {
        return () => {
            if (blobUrl) {
                URL.revokeObjectURL(blobUrl);
            }
        };
    }, [blobUrl]);


    if (documentFetchStatus === 'loading') {
        return (
            <div
              className="text-center"
            >
              <h6 style={{marginTop:5}}>
                <img
                  src={require("../../assets/time_gif.gif")}
                  width="50"
                  height="50"
                />
              </h6>
            </div>
        );
    } else if (documentFetchStatus === 'error') {
        return (
            <div className="flex justify-center items-center h-64 bg-red-100">
                <div className="text-xl text-red-600">Failed to load PDF.</div>
            </div>
        );
    } else if (!blobUrl) {
        return (
            <div className="flex justify-center items-center h-64">
                <div className="text-xl">No PDF content available.</div>
            </div>
        );
    }

    return (
        <div className="pdf-viewer-container h-screen flex flex-col">
        <AlertMessage
          message={alertMessage}
          onClose={() => setAlertMessage("")}
          variant={"success"}
        />
            <div className="flex-grow relative">
                <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
                    <Viewer
                        fileUrl={blobUrl}
                        plugins={[searchPluginInstance]}
                        scrollMode={ScrollMode.Vertical}
                        onDocumentLoad={() => setPdfLoaded(true)}
                    />
                </Worker>
                {(currentLocation && currentLocation.length > 1 && currentLocation.index > 0) &&
                    <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">{`${currentLocation.index + 1} of ${currentLocation.length} matches `}</Tooltip>} placement={'auto'}>
                        <button
                            onClick={() => setCurrentLocation(prev => ({ ...prev, index: prev.index - 1 }))}
                            style={{
                                top: '110px',
                                left: '870px',
                            }}
                            className="search-navigate-button"
                        >
                            <RiArrowUpLine />
                        </button>
                    </OverlayTrigger>
                }
                {(currentLocation && currentLocation.length > 1 && currentLocation.index != currentLocation.length - 1) &&
                    <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">{`${currentLocation.index + 1} of ${currentLocation.length} matches `}</Tooltip>} placement={'auto'}>
                        <button
                            onClick={() => setCurrentLocation(prev => ({ ...prev, index: prev.index + 1 }))}
                            style={{
                                top: '400px',
                                left: '870px',
                            }}
                            className="search-navigate-button"
                        >
                            <RiArrowDownLine />
                        </button>
                    </OverlayTrigger>
                }

            </div>
        </div>
    );
};

export default DocumentViewer;
